<template>
  <article class="bg-white insurance-quote-wrap">
    <p class="pay-bg-dfe4f0">最终价格以出单为准</p>
    <section class="tagPay">
      <cell :title="data.plate_number" :inline-desc="data.vin" class="pay-car-info">
          <img slot="icon" src="../../stylesheets/images/car1.png" class="select-img">
      </cell>
    </section>
    <section class="bg-white">
      <div class="line-20"></div>
      <div class="company-list">
        <p>投保公司：{{ data.insurance_company || ''}}</p>
        <p class="last-company" v-if="data.last_insurance_company !== undefined">上年投保公司：{{ data.last_insurance_company || ''}}</p>
      </div>

      <div class="insurance-list-box">
        <!-- 商业保险 -->
        <div v-if="data.commercial" class="cell-height vux-1px-b">
          <cell title="商业险">
            <span slot="after-title" class="col-grey">
              ({{data.commercial.insurance_effected_on | formatTime}} - {{data.commercial.insurance_expires_on | formatTime}})
            </span>
            <span slot="icon" class="hd"></span>
            <div slot="value" class="cl-black">{{ data.commercial.total | priceToTxt }}</div>
          </cell>
          <template v-if="data.commercial && data.commercial.items">
            <div  v-for="(item,index) in data.commercial.items" :key="item.name" class="insurance-list">
                <div v-if="index === 0" class="insurance-list-line" :class="{ 'vux-1px-t': index === 0 }"></div>
                <p  class="detail-hd ">
                    {{item | getString}}
                </p>
            </div>
            <div class="insurance-list-bottom"></div>
          </template>
        </div>
        <!-- 商业保险 -->

        <!-- 交强险 -->
        <div v-if="data.compulsory"  class="cell-height vux-1px-b">
          <cell title="交强险">
            <span slot="after-title" class="col-grey">
              ({{ data.compulsory.insurance_effected_on | formatTime}} - {{ data.compulsory.insurance_expires_on | formatTime}})
            </span>
            <span slot="icon" class="hd"></span>
            <div slot="value" class="cl-black">{{ data.compulsory.total | priceToTxt }}</div>
          </cell>
        </div>
        <!-- 交强险 -->

        <!-- 车船税 -->
        <div v-if="data.compulsory"  class="cell-height">
          <cell title="车船税">
            <span slot="after-title" class="col-grey"></span>
            <span slot="icon" class="hd"></span>
            <div slot="value" class="cl-black">{{ data.tax | priceToTxt }}</div>
          </cell>
        </div>
        <!-- 车船税 -->

      </div>

      <div class="list-total quote-total vux-1px-t">
        <p><span>合计保费：</span><i class="fc-fb3f3f">{{ data.total | priceToTxt }}</i></p>
      </div>
      <!-- 解决iPhone7适配 -->
      <div class="line-30"></div>
    </section>

  </article>
</template>
<script>
import { Cell } from '@lx-frontend/cvux'
import util from '../../common/util'

export default {
  components: { Cell },
  data () {
    return {
      data: {
        commercial: {
          items: []
        },
        compulsory: {}
      }
    }
  },
  created() {
    this.getQuoteInfo()
  },
  methods: {
    getQuoteInfo() {
      let quoteId = this.$route.params.id
      let source = this.$route.params.source || ''
      const rest = source && source === 'gateway' ? 'infoFromGateway' : 'info'
      this.$rest.insurance.quote[rest](null, quoteId).then(res => {
        if (res.code === 0) {
          if (res.data.commercial) {
            // 对返回的数据进行排序
            res.data.commercial.items.sort((a, b) => {
              return a.sequence - b.sequence
            })
          }
          this.data = res.data
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  filters: {
    formatTime(time) {
      return util.formatTime(time, 'yyyy.MM.dd')
    },
    priceToTxt(price) {
      let priceGet = ''
      if (price) {
        priceGet = '￥' + (price / 100).toFixed(2)
      } else {
        priceGet = '￥' + 0.00
      }
      return priceGet
    },
    getString(obj) {
      if (!obj) return ''
      let str = ''
      let amount = obj.amount
      let name = obj.name
      let seatNum = obj.seats
      let glassType = obj.country_type
      let amountStr = ''
      let times = obj.times
      let rate = obj.rate
      const type = ['国产', '进口']
      if (amount) {
        amountStr = (amount / 100).toFixed(2)
      } else {
        amountStr = 0.00
      }
      // 显示名称
      str = name + ' '
      // 判断是否显示不计免赔
      if (obj.is_select_ndi === true) {
        str += '- 不计免赔 '
      }
      if (seatNum) {
        str += ' (' + seatNum + '座 * ' + amountStr + '元)'
      } else {
        // 判断是否显示价格
        if (amount !== 0 && !times && !rate) {
          str += ' (' + amountStr + '元)'
        }
      }
      // 处理玻璃增值服务
      if (glassType) {
        str += ' (' + type[ glassType - 1 ] + ')'
      }
      // 处理次数
      if (times) {
        str = `${str} (${times}次)`
      }
      // 处理百分比
      if (rate) {
        str = `${str} (${rate / 100}%)`
      }
      // if (obj.country_type) {
      //   str += ' (' + glassType[obj.country_type - 1] + ')'
      // }
      return str
    }
  }
}
</script>

<style scoped lang="less">
@import '../../stylesheets/modules/insurance/quoteInfo.less';
@import '~@lx-frontend/cvux/src/styles/common/1px.less';
</style>
